import { useContext, useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PanelMenu } from "primereact/panelmenu"
import { LoaderProgressBar } from "../../Loaders"
import { UserContext } from "../../../context/userContext"
import {
  buildPanelMenuModel,
  renderMaterialIconMenuItemTemplate,
} from "./helpers/menuBuilder"
import useMainMenu from "../../../hooks/useMainMenu"

// hooks
import useMenuItems from "./hooks/useMenuItems"

import baseStyles from "../../../styles/SidebarPanelMenuBase.module.css"

export default function ParticipantMenu() {
  const { current_participant_id, participant_membership_status } =
    useContext(UserContext)
  const navigate = useNavigate()
  const location = useLocation()
  const { resolveMenuPath } = useMainMenu()
  // `useMenuItems` returns [loading, items] for the requested sidebar context.
  const [loading, items] = useMenuItems("participant")

  const participantMenuModel = useMemo(() => {
    // Shared helper handles route matching, active-class assignment, and parent expansion propagation.
    return buildPanelMenuModel({
      items,
      pathname: location.pathname,
      navigate,
      itemTemplate: renderMaterialIconMenuItemTemplate,
      activeClassName: baseStyles.menuLinkActiveItem,
      resolvePath: resolveMenuPath,
      // Hide Discharge for already discharged participants.
      includeItem: ({ item, depth }) => {
        if (depth !== 0) {
          return true
        }

        const isDischargePath = item?.path === "/form/discharge_session/1"
        const isParticipantDischarge =
          participant_membership_status === "Inactive Discharged"

        return !(isDischargePath && isParticipantDischarge)
      },
    })
  }, [
    items,
    location.pathname,
    navigate,
    participant_membership_status,
    resolveMenuPath,
  ])

  if (current_participant_id === null) return null
  if (loading) return <LoaderProgressBar />

  if (!participantMenuModel.length) return null

  return (
    <div className={baseStyles.menuRoot}>
      <PanelMenu
        // Remount on pathname change so PrimeReact re-reads `expanded` flags from the model.
        key={`participant-menu-${location.pathname}`}
        model={participantMenuModel}
        multiple={false}
      />
    </div>
  )
}
